import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const ProductsLayout = () => {
  const navList = useNav();
  let { productsBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={productsBottomHeader} topTabs={OperationsTopHeader} />
      <Outlet />
    </div>
  );
};

export default ProductsLayout;
